import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=146accbc&lang=scss&scoped=true"

import exportComponent from "/Users/lgd_sunday/Desktop/个人/Imooc/基于 vue-element-admin 的后台综合解决方案/讲义代码/imooc-admin/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146accbc"]])

export default __exports__